// import React from 'react';
// import './NewTab.css';
// import { useSelector } from 'react-redux';

// const NewTab = ({ handleTabClick }) => {
//   const activeTab = useSelector((state) => state.operationHome.activeTab);

//   return (
//     <div className="tabulation-container">
//       <ul className="option-list">
//         {/* Tab for Last Updated */}
//         <li className="tab-item">
//           <button
//             className={`tab-button ${activeTab === "last24Hours" ? "selected" : ""}`}
//             onClick={() => handleTabClick({ name: "last24Hours" })}
//           >
//             Last Updated <span className="highlight-text">12 Dec. 2024</span>
//           </button>
//         </li>
//         {/* Tab for Calls */}
//         <li className="tab-item">
//           <button
//             className={`tab-button ${activeTab === "last7Days" ? "selected" : ""}`}
//             onClick={() => handleTabClick({ name: "last7Days" })}
//           >
//             <label className="checkbox-container">
//               <input
//                 type="checkbox"
//                 className="checkbox-input"
//                 // Add logic to handle checkbox state if needed
//               />
//               <span className="checkbox-label">
//                 100/1000 calls
//                 <span className="subtext">(Applies to Progression and My Opportunity only)</span>
//               </span>
//             </label>
//           </button>
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default NewTab;

// import React from 'react';
// import './NewTab.css';
// import { useSelector } from 'react-redux';

// const NewTab = ({ handleTabClick }) => {
//     const activeTab = useSelector((state) => state.operationHome.activeTab);

//     return (
//         <div className="tabulation-container">
//             {/* Combined Last Updated and Calls Section */}
//             <div className="tab-row">
//                 {/* Last Updated Section */}
//                 <div
//                     className="tab-item underline "

//                 >
//                     Last Updated 12 Dec. 2024
//                 </div>

//                 {/* Calls Section */}
//                 <div className="calls-section">
//                     <input
//                         type="checkbox"
//                         className="checkbox"
//                         name="option1"
//                     // checked={selectedOptions.option1}
//                     // onChange={handleCheckboxChange}
//                     />
//                     <div
//                         className="tab-calls"

//                     >
//                         <span>100/1000 calls</span>
//                         <span className="subtext">
//                             (Applies to <span className="black-text">Progression</span> and <span className="black-text">My Opportunity</span> only)
//                         </span>

//                     </div>
//                 </div>

//                 <div className="calls-section">
//                     <input
//                         type="checkbox"
//                         className="checkbox"
//                         name="allCalls"
//                         checked={selectedOptions.allCalls}
//                         onChange={handleCheckboxChange}
//                     />
//                     <div
//                         className="tab-calls"

//                     >
//                         <span>All calls</span>
//                         {/* <span className="subtext">
//                             (Applies to <span className="black-text">Progression</span> and <span className="black-text">My Opportunity</span> only)
//                         </span> */}

//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default NewTab;

// import React, { useState } from "react";
// import "./NewTab.css";
// import { useSelector } from "react-redux";

// const NewTab = ({ handleTabClick }) => {
//   const activeTab = useSelector((state) => state.operationHome.activeTab);

//   // State for checkboxes
//   const [selectedOptions, setSelectedOptions] = useState({
//     allCalls: true, // Default to checked
//     specificCalls: false,
//   });

//   const handleCheckboxChange = (event) => {
//     const { name, checked } = event.target;

//     setSelectedOptions((prevState) => ({
//       ...prevState,
//       [name]: checked,
//     }));

//     // Trigger graph update logic based on the selected option
//     if (name === "allCalls" && checked) {
//       console.log("All calls selected. Updating graph...");
//       // Add logic to update graph for all calls
//     } else if (name === "specificCalls" && checked) {
//       console.log("Specific calls selected. Updating graph...");
//       // Add logic to update graph for specific calls
//     }
//   };

//   return (
//     <div className="tabulation-container">
//       {/* Combined Last Updated and Calls Section */}
//       <div className="tab-row">
//         {/* Last Updated Section */}
//         {/* <div className="tab-item underline">
//                     Last Updated 12 Dec. 2024
//                 </div> */}
//         <div className="text-data">As per Last 100 calls</div>

//         {/* Calls Section */}
//         {/* <div className="calls-section">
//                     <input
//                         type="checkbox"
//                         className="checkbox"
//                         name="specificCalls"
//                         checked={selectedOptions.specificCalls}
//                         onChange={handleCheckboxChange}
//                     />
//                     <div className="tab-calls">
//                         <span>100/1000 calls</span>
//                         <span className="subtext">
//                             (Applies to <span className="black-text">Progression</span> and <span className="black-text">My Opportunity</span> only)
//                         </span>
//                     </div>
//                 </div>

//                 <div className="calls-section">
//                     <input
//                         type="checkbox"
//                         className="checkbox"
//                         name="allCalls"
//                         checked={selectedOptions.allCalls}
//                         onChange={handleCheckboxChange}
//                     />
//                     <div className="tab-calls">
//                         <span>All calls</span>
//                     </div>
//                 </div> */}
//       </div>
//     </div>
//   );
// };

// export default NewTab;

import React, { useState } from "react";
import "./NewTab.css";
import { useSelector } from "react-redux";

const NewTab = ({ handleTabClick }) => {
  const activeTab = useSelector((state) => state.operationHome.activeTab);

  // State for checkboxes
  const [selectedOptions, setSelectedOptions] = useState({
    allCalls: true, // Default to checked
    specificCalls: false,
  });

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: checked,
    }));

    // Trigger graph update logic based on the selected option
    if (name === "allCalls" && checked) {
      console.log("All calls selected. Updating graph...");
      // Add logic to update graph for all calls
    } else if (name === "specificCalls" && checked) {
      console.log("Specific calls selected. Updating graph...");
      // Add logic to update graph for specific calls
    }
  };

  return (
    <div className="tabulation-container">
      {/* Combined Last Updated and Calls Section */}
      <div className="tab-row">
        {/* Last Updated Section */}
        {/* <div className="tab-item underline">
                    Last Updated 12 Dec. 2024
                </div> */}
        <div className="lastCall-data">As per Last ≤ 100 calls</div>

        {/* Calls Section */}
        {/* <div className="calls-section">
                    <input
                        type="checkbox"
                        className="checkbox"
                        name="specificCalls"
                        checked={selectedOptions.specificCalls}
                        onChange={handleCheckboxChange}
                    />
                    <div className="tab-calls">
                        <span>100/1000 calls</span>
                        <span className="subtext">
                            (Applies to <span className="black-text">Progression</span> and <span className="black-text">My Opportunity</span> only)
                        </span>
                    </div>
                </div>

                <div className="calls-section">
                    <input
                        type="checkbox"
                        className="checkbox"
                        name="allCalls"
                        checked={selectedOptions.allCalls}
                        onChange={handleCheckboxChange}
                    />
                    <div className="tab-calls">
                        <span>All calls</span>
                    </div>
                </div> */}
      </div>
    </div>
  );
};

export default NewTab;
